import { defineNuxtMiddleware } from '@nuxtjs/composition-api';

import { useClosedSalesStore } from '@/features/closed-sales';

export default defineNuxtMiddleware(async ({ route, from }) => {
  const fromPath = from?.path;
  const toPath = route?.path;

  if (!fromPath || toPath === '/') {
    const {
      handlerCheckStatus,
    } = useClosedSalesStore();
    await handlerCheckStatus();
  }
});
